import React from "react";
import { Checkbox, Box, Typography, Tooltip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  SocialPlatforms,
  socialPlatformIcons,
  socialPlatformTitles,
  socialBrandColors,
} from "../../../../constants/SocialPlatforms";
import styled from "styled-components";

export interface IconFilters {
  onFilterSelected: (sp: SocialPlatforms | undefined) => void;
  selectedFilter: SocialPlatforms | undefined;
}

const IconFilters: React.FC<IconFilters> = ({
  onFilterSelected,
  selectedFilter,
}) => {
  return (
    <IconFilterContainer>
      <Typography variant="subtitle2">Platform</Typography>
      <Box>
        <Box display="flex">
          <Box marginX={1}>
            <Checkbox
              checked={selectedFilter === undefined}
              onChange={() => onFilterSelected(undefined)}
              icon={<span style={{ color: "#999" }}>All</span>}
              checkedIcon={<span>All</span>}
            />
          </Box>
          {Object.keys(socialPlatformIcons).map((k) => {
            const key = k as SocialPlatforms;
            return (
              <Box marginX={1} key={key}>
                <Tooltip title={socialPlatformTitles[key]}>
                  <Checkbox
                    checked={selectedFilter === key}
                    icon={
                      <FontAwesomeIcon
                        icon={socialPlatformIcons[key]}
                        color="#999999"
                      />
                    }
                    checkedIcon={
                      <FontAwesomeIcon
                        icon={socialPlatformIcons[key]}
                        color={socialBrandColors[key]}
                      />
                    }
                    onChange={() => onFilterSelected(key)}
                  />
                </Tooltip>
              </Box>
            );
          })}
        </Box>
      </Box>
    </IconFilterContainer>
  );
};

export default IconFilters;

const IconFilterContainer = styled(Box)`
  background: ${(props) => props.theme.colors.grey.default};
  padding: 8px 16px;
`;
